import { get } from 'lodash';
import qs from 'querystringify';

export default function getPageId({ meterParam = '', meterPath = false }) {
  const title = get(document.querySelector('title'), 'textContent', '');
  const titleWithoutGlobe = title.split('- The Boston Globe')[0].trim();
  const alpha = titleWithoutGlobe.replace(/\W+/g, '-');
  let suffix = '';

  if (meterPath) {
    const pathname = window.location.pathname
      .split('/')
      .filter((str) => str !== '')
      .join('-');
    const path = `-path-${pathname}`;

    suffix += path;
  }

  if (meterParam.length > 0) {
    const search = qs.parse(window.location.search);
    const paramValue = search[meterParam];
    const paramStr = paramValue ? (
      `-${meterParam}-${paramValue}`
    ) : '';

    suffix += paramStr;
  }

  return `apps.${alpha}${suffix}`.toLowerCase();
}
